import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs?.extend?.(duration);

export const formatMinutesSeconds = (seconds: number) =>
  dayjs
    .duration({
      seconds: Math.floor(seconds % 60),
      minutes: Math.floor(seconds / 60),
    })
    .format('mm:ss');
